import { useEffect, useState } from "react";
import { CheckCircle2, ChevronRight, KeyRound, ShieldAlert } from "lucide-react";
import { call, formatError } from "@/lib/api";

export default function ResetPassword({ token, onDone }) {
  const [state, setState] = useState({ status: "checking" });
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [ok, setOk] = useState("");
  useEffect(() => { call.get(`/auth/reset-password/validate?token=${encodeURIComponent(token || "")}`).then(r => setState(r.valid ? { status: "valid", email: r.email } : { status: "invalid" })).catch(() => setState({ status: "invalid" })); }, [token]);
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw !== pw2) { setErr("Konfirmasi password tidak sama"); return; }
    setBusy(true);
    try { const r = await call.post("/auth/reset-password", { token, password: pw }); setOk(r.message); }
    catch (x) { setErr(formatError(x, "Gagal mengubah password")); }
    finally { setBusy(false); }
  };
  return (
    <main className="login-shell reset-shell">
      <div className="login-art">
        <div className="login-logo-plate"><img src="/brand/pkm-logo.webp" alt="PT Prime Karya Mandiri" /></div>
        <div className="login-art-copy"><span>CONTRACTOR ERP</span><h1>Password<br /><em>baru.</em></h1><p>Buat password yang kuat: minimal 8 karakter, gabungan huruf dan angka.</p></div>
        <div className="login-art-meta">PT PRIME KARYA MANDIRI <span>•</span> 2026</div>
      </div>
      <div className="login-form-wrap">
        <div className="mobile-brand"><img src="/brand/pkm-logo.webp" alt="PT Prime Karya Mandiri" /></div>
        <div className="login-form" data-testid="reset-password-page">
          <span className="eyebrow">ATUR ULANG PASSWORD</span>
          {state.status === "checking" && <p className="muted">Memeriksa tautan…</p>}
          {state.status === "invalid" && <>
            <h2>Tautan tidak valid.</h2>
            <div className="error" data-testid="reset-invalid"><ShieldAlert size={16} /> Tautan reset sudah kedaluwarsa atau pernah dipakai. Silakan minta tautan baru dari halaman masuk.</div>
            <button className="primary-btn" data-testid="reset-back-button" onClick={onDone}>Ke halaman masuk <ChevronRight size={16} /></button>
          </>}
          {state.status === "valid" && (ok ? <>
            <h2>Password diperbarui.</h2>
            <div className="login-sent" data-testid="reset-success"><CheckCircle2 size={18} /> <span>{ok}</span></div>
            <button className="primary-btn" data-testid="reset-login-button" onClick={onDone}>Masuk sekarang <ChevronRight size={16} /></button>
          </> : <>
            <h2>Buat password baru.</h2>
            <p className="muted">Untuk akun <b data-testid="reset-email">{state.email}</b></p>
            <form onSubmit={submit}>
              <label>Password baru<input data-testid="reset-password-input" type="password" autoComplete="new-password" minLength={8} value={pw} onChange={e => setPw(e.target.value)} required /></label>
              <label>Ulangi password<input data-testid="reset-password-confirm" type="password" autoComplete="new-password" minLength={8} value={pw2} onChange={e => setPw2(e.target.value)} required /></label>
              {err && <div className="error" data-testid="reset-error">{err}</div>}
              <button data-testid="reset-submit-button" className="primary-btn" type="submit" disabled={busy}><KeyRound size={15} /> {busy ? "Menyimpan…" : "Simpan password baru"}</button>
            </form>
          </>)}
        </div>
      </div>
    </main>
  );
}
